import { IModel } from "@/@types/models/model";
import { coreFields } from "@/models/helpers/coreFields";
import { hpsFields } from "./helpers/hpsFields";

const IzletVodicSudionik: IModel = {
  title: "Vodici i sudionici",
  apiPath: "hps/izleti/{id}/vodici-i-sudionici",
  httpUpdateVerb: "put",
  forms: {
    default: {
      fields: ["id"],
    },
    // TODO add forms for each variant
  },
  listViews: {
    default: {
      fields: ["id", "first_name", "last_name", "uloga", "hps_plan_udruga_id", "hps_spv_id"],
      hidden: ["id"]
    }
  },
  fields: [
    coreFields.id,
    {
      title: "Ime",
      source: "first_name",
      ttoken: "users.first_name",
      type: "text",
      filter: true,
      readonly: true
    },
    {
      title: "Prezime",
      source: "last_name",
      ttoken: "users.last_name",
      type: "text",
      filter: true,
      readonly: true
    },
    hpsFields.hps_plan_udruga_id,
    hpsFields.hps_spv_id,
    {
      title: "Vodic label", // hacky for picker cuz i don't know any better jbg
      source: "label",
      ttoken: "common.label",
      type: "text",
      readonly: true,
    },
    {
      title: "Vodic value", // hacky for picker cuz i don't know any better jbg
      source: "value",
      ttoken: "common.value",
      type: "number",
      readonly: true,
    },
    {
      title: "User ID", // hacky for picker cuz i don't know any better jbg
      source: "user_id",
      ttoken: "common.user",
      type: "number",
      readonly: true,
    },
    {
      title: "Uloga",
      source: "uloga",
      ttoken: "hps.izleti.uloga",
      type: "picker",
      items: {
        labels: ["hps.izlet-uloge.vodic", "hps.izlet-uloge.sudionik"],
        values: [10, 20]
      },
      readonly: true,
      translate: true,
    },

    coreFields.created_by,
    coreFields.created_on
  ],
};

export default IzletVodicSudionik;
